import { useEffect, useState } from "react";

/**
 * Возвращает `true` только если входной флаг был `true` дольше, чем
 * `delayMs`. Полезно чтобы не показывать скелет/спиннер на быстрых
 * (≤200ms) запросах — пользователь не успевает заметить мелькание,
 * а мы убираем визуальный «прыг» когда контент приходит сразу.
 */
export function useDelayedFlag(flag: boolean, delayMs: number): boolean {
    const [delayed, setDelayed] = useState(false);

    useEffect(() => {
        if (!flag) {
            setDelayed(false);
            return;
        }
        const id = window.setTimeout(() => setDelayed(true), delayMs);
        return () => window.clearTimeout(id);
    }, [flag, delayMs]);

    return delayed;
}
